import { z } from 'zod'

import { baseInstrumentSchema } from '@/pages/instruments/new-instrument/schemas/shared/base.schema'

export const equitySchema = baseInstrumentSchema.extend({
  instrument_type: z.literal('equity'),
  isin: z.string().length(12, 'Must be exactly 12 characters long.'),
  currency_id: z.number().int(),
  country_id: z.number().int(),
  counterparty_id: z.number().int(),
  bbg_ticker: z.string().min(1),
  company_name: z.string().min(1),
  description: z.string().min(1),
})

export type EquitySchemaType = z.infer<typeof equitySchema>
